module.exports = __webpack_public_path__ + "img/horizontal_7_4_9005.f052d31e.png";